module.exports = __webpack_public_path__ + "img/background05.77e5427a.png";